module.exports = __webpack_public_path__ + "Images/blue-circle.png";


//////////////////
// WEBPACK FOOTER
// ./Images/timeline_js/images/blue-circle.png
// module id = 1844
// module chunks = 2